var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1637 21.4964C11.0705 21.4422 9.04894 20.771 7.35062 19.5797C6.87788 19.2481 6.83278 18.5907 7.21046 18.1567C7.59332 17.7168 8.26411 17.6751 8.75243 17.9984C10.0722 18.872 11.6192 19.3632 13.2185 19.4046C15.1743 19.4554 17.0873 18.8302 18.6314 17.6358C20.1756 16.4415 21.2555 14.7517 21.687 12.8545C22.1186 10.9573 21.8751 8.97003 20.9981 7.23128C20.1211 5.49254 18.6648 4.10994 16.8774 3.31897C15.0901 2.528 13.0821 2.37773 11.1958 2.8937C9.30943 3.40966 7.66134 4.55987 6.5324 6.14852C5.66939 7.36289 5.15054 8.77599 5.01696 10.241C4.98474 10.5944 5.27798 10.885 5.63836 10.885H7.06213C7.57843 10.885 7.88632 11.4516 7.59982 11.8745L4.39246 16.6087C4.13661 16.9863 3.57294 16.9863 3.31709 16.6087L0.109733 11.8745C-0.176772 11.4516 0.13112 10.885 0.64742 10.885H2.239C2.59322 10.885 2.87941 10.604 2.90427 10.2561C3.04018 8.35386 3.69564 6.51397 4.81345 4.94103C6.22339 2.95708 8.28162 1.52047 10.6375 0.87615C12.9933 0.231744 15.501 0.419497 17.7333 1.40723C19.9655 2.39506 21.7842 4.12178 22.8795 6.29331C23.9747 8.46476 24.2788 10.9466 23.7398 13.3161C23.2009 15.6855 21.8523 17.7958 19.9238 19.2874C17.9953 20.7791 15.6062 21.5597 13.1637 21.4964Z",
    fill: "#00a000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.fdaa9d2c0ba0b0736d84224916e42c6d.svg";
export { ForwardRef as ReactComponent };